<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M8 15.1667C11.6819 15.1667 14.6667 12.1819 14.6667 8.50001C14.6667 4.81811 11.6819 1.83334 8 1.83334C4.3181 1.83334 1.33334 4.81811 1.33334 8.50001C1.33334 12.1819 4.3181 15.1667 8 15.1667Z"
      stroke="currentColor"
    />
    <path
      d="M6.33334 6.83334L8.6666 9.16641M10.6667 5.83334L7.33334 9.16668"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts">
</script>